export const isMobileUser = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

export const isMac = () => {
    return navigator.userAgent.toUpperCase().indexOf('MAC') >= 0;
};